/**
 * Wrapper class to handle error messages comming from the backend.
 * @param {Integer} statusCode error code
 * @param {Array} errors array of errors [{ key, data }]
 * @param {String} errors error title
 */
export default class ApiError extends Error {
    constructor(statusCode, errors, title) {
        super(title);
        this.name = 'ApiError';

        this.errors = errors;
        this.statusCode = statusCode;

        /**
         * Get Value must:
         * - return the value if the key exists in the errors arrays.
         * @param {String} key error key
         */
        this.getValue = function(key) {
            const error = this.errors.find(error => error.key === key);
            return error ? error : null;
        };

        if (Error.hasOwnProperty('captureStackTrace')) {
            Error.captureStackTrace(this, ApiError);
        }
        this.stack = new Error(title).stack;
    }
}
